function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 13.5H11",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 11.5H11",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.66683 11.4987H1.66683C1.31353 11.4976 0.975006 11.3568 0.725186 11.107C0.475366 10.8572 0.334551 10.5187 0.333496 10.1654V6.16536C0.334551 5.81207 0.475366 5.47354 0.725186 5.22372C0.975006 4.9739 1.31353 4.83309 1.66683 4.83203H14.3335C14.6868 4.83309 15.0253 4.9739 15.2751 5.22372C15.525 5.47354 15.6658 5.81207 15.6668 6.16536V10.1654C15.6658 10.5187 15.525 10.8572 15.2751 11.107C15.0253 11.3568 14.6868 11.4976 14.3335 11.4987H12.3335",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.6665 3.4987V0.832031H10.0572C10.234 0.832069 10.4035 0.902332 10.5285 1.02736L12.1378 2.6367C12.2629 2.76169 12.3331 2.93123 12.3332 3.10803V3.4987",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3332 15.5C12.3332 15.6768 12.2629 15.8464 12.1379 15.9714C12.0129 16.0964 11.8433 16.1667 11.6665 16.1667H4.33317C4.15636 16.1667 3.98679 16.0964 3.86177 15.9714C3.73674 15.8464 3.6665 15.6768 3.6665 15.5V9.5H12.3332V15.5Z",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.33317 7.4974C2.70136 7.4974 2.99984 7.19892 2.99984 6.83073C2.99984 6.46254 2.70136 6.16406 2.33317 6.16406C1.96498 6.16406 1.6665 6.46254 1.6665 6.83073C1.6665 7.19892 1.96498 7.4974 2.33317 7.4974Z",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.6665 0.832031V3.4987H12.3332",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0 0.5)"
})));

var SvgPrint = function SvgPrint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/print.1fa771c7.svg";
export { ForwardRef as ReactComponent };